import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import ApiServices from "../services/apiservices";

const LatestNewsTicker = () => {
  const [news, setNews] = useState([]);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await ApiServices.getRequest("/posts/latest-news.php");
        if (res.posts && res.posts.length > 0) {
          setNews([...res.posts]);
        }
      } catch (err) {
        console.error("Error fetching news:", err);
      }
    };

    fetchNews();
  }, []);

  return (
    <div
      className="w-full bg-black border-b border-green-700/30 text-white overflow-hidden flex items-center h-10 sm:h-11 md:h-12"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* LABEL */}
      <div
        className="
          bg-[#facc15]
          pl-2 pr-4
          sm:pl-4 sm:pr-8
          md:pl-5 md:pr-10
          lg:pl-6 lg:pr-12
          py-2
          flex
          items-center
          relative
          z-20
          h-full
          shrink-0
          shadow-[10px_0_20px_rgba(0,0,0,0.5)]
        "
        style={{
          clipPath: "polygon(0% 0%,92% 0%,100% 50%,92% 100%,0% 100%)",
        }}
      >
        <span
          className="
            font-black
            text-black
            text-[11px]
            sm:text-xs
            md:text-sm
            lg:text-base
            whitespace-nowrap
            uppercase
            tracking-wide
            md:tracking-widest
          "
        >
          {/* Mobile */}
          <span className="inline sm:hidden">🔥 Updates</span>

          {/* Tablet & Desktop */}
          <span className="hidden sm:inline">🔥 Latest Updates</span>
        </span>
      </div>

      {/* MARQUEE */}
      <div className="relative flex-1 overflow-hidden h-full flex items-center bg-black">
        <motion.div
          className="flex whitespace-nowrap gap-12 items-center"
          animate={{
            x: paused ? 0 : ["0%", "-50%"],
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 25,
              ease: "linear",
            },
          }}
          style={{
            display: "flex",
            width: "fit-content",
          }}
        >
          {/* Welcome to the new BEDC Electricity web portal */}
          {news.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 group cursor-pointer"
            >
              <div className="w-2 h-2 bg-green-500 rounded-full group-hover:bg-yellow-400 transition-colors"></div>

              {item.image && (
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-8 h-6 object-cover rounded-sm grayscale group-hover:grayscale-0 transition-all border border-gray-800"
                />
              )}
              <p className="text-xs sm:text-sm md:text-base font-bold uppercase tracking-wide text-gray-200 group-hover:text-[#facc15] transition-colors">
                <a href={`/${item.postLinkTitle}`}>
                  {item.title}
                </a>
                <span className="ml-8 md:ml-12 text-gray-700">|</span>
              </p>
            </div>
          ))}
        </motion.div>

        {/* Left Fade */}
        <div className="absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none"></div>

        {/* Right Fade */}
        <div className="absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none"></div>
      </div>
    </div>
  );
};

export default LatestNewsTicker;